import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function MessagesIcon({ className }: IconProps) {
  return (
    <svg
      width="90"
      height="97"
      viewBox="0 0 90 97"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1429)">
        <path
          d="M71.0132 97H18.9564C15.064 97 11.8848 93.8528 11.8848 89.9336V7.06642C11.8848 3.17692 15.0343 0 18.9564 0H71.0132C74.9056 0 78.0848 3.14723 78.0848 7.06642V89.9336C78.0848 93.8231 74.9353 97 71.0132 97Z"
          fill="#EAEDF8"
        />
        <path
          d="M67.5078 86.4003H22.493C19.5811 86.4003 17.2041 84.025 17.2041 81.1153V15.8548C17.2041 12.9451 19.5811 10.5698 22.493 10.5698H67.4781C70.39 10.5698 72.767 12.9451 72.767 15.8548V81.1153C72.767 84.025 70.39 86.4003 67.4781 86.4003"
          fill="white"
        />
        <path
          d="M52.2647 6.62115H38.5968C37.854 6.62115 37.2598 6.02733 37.2598 5.28506C37.2598 4.54279 37.854 3.94897 38.5968 3.94897H52.2647C53.0075 3.94897 53.6018 4.54279 53.6018 5.28506C53.6018 6.02733 53.0075 6.62115 52.2647 6.62115Z"
          fill="#00416B"
        />
        <path
          d="M60.4358 5.28496C60.4358 6.26476 59.6336 7.03672 58.6827 7.03672C57.7319 7.03672 56.9297 6.23507 56.9297 5.28496C56.9297 4.33486 57.7319 3.5332 58.6827 3.5332C59.6336 3.5332 60.4358 4.33486 60.4358 5.28496Z"
          fill="#00C4B3"
        />
        <path
          d="M47.2131 91.6853C47.2131 92.6651 46.4109 93.4371 45.4601 93.4371C44.5093 93.4371 43.707 92.6355 43.707 91.6853C43.707 90.7352 44.5093 89.9336 45.4601 89.9336C46.4109 89.9336 47.2131 90.7352 47.2131 91.6853Z"
          fill="#00416B"
        />
        <path
          d="M62.219 91.6853C62.219 92.6651 61.4168 93.4371 60.4659 93.4371C59.5151 93.4371 58.7129 92.6355 58.7129 91.6853C58.7129 90.7352 59.5151 89.9336 60.4659 89.9336C61.4168 89.9336 62.219 90.7352 62.219 91.6853Z"
          fill="#00C4B3"
        />
        <path
          d="M32.2083 91.6853C32.2083 92.6651 31.406 93.4371 30.4552 93.4371C29.5044 93.4371 28.7021 92.6355 28.7021 91.6853C28.7021 90.7352 29.5044 89.9336 30.4552 89.9336C31.406 89.9336 32.2083 90.7352 32.2083 91.6853Z"
          fill="#00C4B3"
        />
        <path
          d="M89.9996 67.1311C89.9996 70.1299 87.5632 72.5645 84.5622 72.5645H78.2036L81.3532 82.4813L63.7632 72.5645H35.7441C32.7431 72.5645 30.3066 70.1299 30.3066 67.1311V48.9603C30.3066 45.9615 32.7431 43.5269 35.7441 43.5269H84.5325C87.5334 43.5269 89.9699 45.9615 89.9699 48.9603V67.1311H89.9996Z"
          fill="#00416B"
        />
        <path
          d="M81.8289 51.6026H64.3875C63.7932 51.6026 63.2881 51.0979 63.2881 50.5041C63.2881 49.9103 63.7932 49.4055 64.3875 49.4055H81.8289C82.4528 49.4055 82.9282 49.9103 82.9282 50.5041C82.9282 51.0979 82.4231 51.6026 81.8289 51.6026Z"
          fill="white"
        />
        <path
          d="M81.8285 59.1146H38.3884C37.7645 59.1146 37.2891 58.6099 37.2891 58.016C37.2891 57.4222 37.7942 56.9175 38.3884 56.9175H81.8285C82.4525 56.9175 82.9279 57.4222 82.9279 58.016C82.9279 58.6099 82.4228 59.1146 81.8285 59.1146Z"
          fill="white"
        />
        <path
          d="M67.1807 66.5965H38.4187C37.7947 66.5965 37.3193 66.0918 37.3193 65.498C37.3193 64.9042 37.8245 64.3994 38.4187 64.3994H67.1807C67.8046 64.3994 68.28 64.9042 68.28 65.498C68.28 66.0918 67.7749 66.5965 67.1807 66.5965Z"
          fill="white"
        />
        <path
          d="M0 46.0505C0 49.0493 2.43645 51.4839 5.43744 51.4839H11.796L8.64642 61.4007L26.2364 51.4839H54.2555C57.2565 51.4839 59.693 49.0493 59.693 46.0505V27.8797C59.693 24.8809 57.2565 22.4463 54.2555 22.4463H5.43744C2.43645 22.4463 0 24.8809 0 27.8797V46.0505Z"
          fill="#00C4B3"
        />
        <path
          d="M52.5024 30.5221H31.5252C30.9012 30.5221 30.4258 30.0173 30.4258 29.4235C30.4258 28.8297 30.9309 28.325 31.5252 28.325H52.5024C53.1263 28.325 53.6017 28.8297 53.6017 29.4235C53.6017 30.0173 53.0966 30.5221 52.5024 30.5221Z"
          fill="white"
        />
        <path
          d="M23.6518 30.5221H7.28004C6.65607 30.5221 6.18066 30.0173 6.18066 29.4235C6.18066 28.8297 6.68578 28.325 7.28004 28.325H23.6518C24.2757 28.325 24.7511 28.8297 24.7511 29.4235C24.7511 30.0173 24.246 30.5221 23.6518 30.5221Z"
          fill="white"
        />
        <path
          d="M52.5029 38.0043H7.28004C6.65607 38.0043 6.18066 37.4995 6.18066 36.9057C6.18066 36.3119 6.68578 35.8071 7.28004 35.8071H52.4732C53.0971 35.8071 53.5725 36.3119 53.5725 36.9057C53.5725 37.4995 53.0674 38.0043 52.4732 38.0043"
          fill="white"
        />
        <path
          d="M36.9334 45.516H7.28004C6.65607 45.516 6.18066 45.0112 6.18066 44.4174C6.18066 43.8236 6.68578 43.3188 7.28004 43.3188H36.9334C37.5574 43.3188 38.0328 43.8236 38.0328 44.4174C38.0328 45.0112 37.5276 45.516 36.9334 45.516Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1429">
          <rect width="90" height="97" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
